import React from 'react'
import CheckForConflictOnProfContent from './CheckForConflictOnProfContent'
import CasePendingInfo from './CasePendingInfo'
import CasePendingInfoOnProfContent from './CasePendingInfoOnProfContent'
import DeniedInfo from './DeniedInfo'

function DetailedStatusInfoOnProfContent({userInfo, onClose, setRefreshList, setCloseMsg, attorney, caseDetails,setUpdateCaseDets,setUpdateComp, isCaseOpen, updateCaseResponse}) {
      const getCloseCaseMessage = (fromUser, toUser, caseDetails) => {
        //who req to close case and if the one who requested is a funder or attorney

        const requester = caseDetails?.userId === toUser?._id ? toUser : fromUser;
        const partner = requester._id === toUser._id ? fromUser : toUser;

        const isRequesterFunder = requester?.isUserFunder;
        const isLoggedInRequester = requester?._id === userInfo?._id;

        console.log("requester, partner, isRequesterFunder, isLoggedInRequester", requester.email, partner.email, isRequesterFunder, isLoggedInRequester, caseDetails?._id, requester?._id, toUser?._id);

        if (isLoggedInRequester) {
            // Logged-in user is the one who requested to close the case
            const partnerRole = isRequesterFunder ? "attorney" : "litigation funding";
            return `You requested to close this case with your ${partnerRole} partner ${partner?.firstName} ${partner?.lastName} from ${partner?.company}. This request is pending approval by the client.`;
        } else {
            // Logged-in user is the partner of the one who requested
            const requesterRole = isRequesterFunder ? "litigation funding" : "attorney";
            const requesterNameOrCompany = isRequesterFunder
            ? requester?.company
            : `${requester?.firstName} ${requester?.lastName} from ${requester?.company}`;
            return `Your ${requesterRole} partner ${requesterNameOrCompany} has requested to close. This request is pending approval by the client.`;
        }
        };
    const stepperContent = (() => {
        switch(caseDetails?.caseStatus)
        {
            case "requested": 
            return <>
            Waiting for approval.. <br/><br/> <DeniedInfo detail={caseDetails}/><br/>Your request for the case has been notified to the client you will receive notification when the client approves you to view the full case details</>
           case "approved": 
            return <CheckForConflictOnProfContent
            attorney={attorney}
            caseDetails={caseDetails.caseDetails}
            setUpdateComp={setUpdateComp}
            onClose={onClose}
            setRefreshList={setRefreshList}
            setUpdateCaseDets={setUpdateCaseDets}
            setCloseMsg={setCloseMsg}
            updateCaseResponse={updateCaseResponse}
            />
            case "noConflict":
            return <>Congratulations, <br/><br/> Now you can view the data and so you can progress to contact the client and sign contracts, download the documents. Once done, make sure to request to close to the client so other professionals dont request to take this case</>
            case "reqToClose":
            return (
                <>
                    {caseDetails?.teamupFromUser && caseDetails?.teamupToUser?._id ?
                        <>
                        {getCloseCaseMessage(caseDetails?.teamupFromUser, caseDetails?.teamupToUser, caseDetails)}
                        </>
                        :
                        <>You requested to close this case and your request to close is pending to be approved by the client</>

            }</>)
            case "closed":
            return <>Congratualtions on closing this case, The case will be deleted from system in 7 days, make sure to download the details.</>
            default:
            return <></>
        }
    })
   
  return (
    <div className=" w-full text-sm">
       {
        !isCaseOpen && caseDetails !== "closed" ?
        <div className='w-full p-6 mb-2  lg:px-20 italic text-center   bg-gray-200'>
            This case is closed now.
        </div>
        :
        <div className=' w-full p-6 mt-6 lg:px-20 italic   bg-green-100'>{stepperContent()}</div>
       }
        </div>
  )
}

export default DetailedStatusInfoOnProfContent